import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

function SelectMileageUnit(props) {
  const [value, setValue] = React.useState(props.value);

  React.useEffect(() => setValue(props.value), [props.value]);

  const options = [
    {value: 'km', label: 'km'},
    {value: 'mi', label: 'mi'},
    {value: 'mth', label: 'mth'},
    {value: 'h', label: 'h'},
  ];

  return <Select
    classNamePrefix="react-select"
    className="w-100"
    options={options}
    value={options.find(o => o.value === value)}
    onChange={option => props.onChange(option.value)}
  />
};

SelectMileageUnit.propTypes = {
  value: PropTypes.oneOf(['km', 'mi', 'mth', 'h']).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectMileageUnit;